import { Wrapper } from 'AppReact';
import styled, { css } from 'styled-components';

const template = styled.div`
  ${({ displayState }) => css`
    min-width: 100px;
    width: 100%;
    height: 58px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;

    background-color: ${displayState?.background ?? ''};
    box-shadow: ${displayState?.isOpen ? '0px 0px 5px 0px rgba(0, 0, 0, 0.09) inset' : ''};

    &:hover {
      box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.09) inset;
    }
  `}
`;

export default Wrapper(template);
